import useOrganizationRootDetailsStore from "@/core/store/organizationRootDetailsStore";

export const checkForNavigationByCategory = () => {
  const { isCategoryNavigationEnabled } = useOrganizationRootDetailsStore();

  return isCategoryNavigationEnabled;
};
